import { ChartColors, LayoutCarousel } from '@silverfort/sf-components';
import TotalMetric from '../../../../components/TotalMetric/TotalMetric';
import { PolicyCountByStatus, PolicyType } from '../../types';

interface PolicyTypeChartProps {
    policyType?: PolicyType;
    policyTypeIsLoading: boolean;
    selectedStatus: keyof PolicyCountByStatus;
}

const PolicyTypeChart = ({ policyType, policyTypeIsLoading, selectedStatus }: PolicyTypeChartProps) => {
    return (
        <LayoutCarousel
            title="Policy type"
            contentClassName="[&]:items-start [&]:justify-start px-6 w-full h-full"
            pages={
                <div className="h-full w-full h-[120px] flex items-center">
                    <TotalMetric
                        title="Total"
                        total={Object.values(policyType?.[selectedStatus] ?? {}).reduce<number>(
                            (acc, curr) => acc + curr,
                            0
                        )}
                        data={[
                            {
                                name: 'Static',
                                value: policyType?.[selectedStatus]?.static ?? 0,
                                fill: ChartColors['data-bg-main-4'],
                                tooltipContent: `Static polices: ${policyType?.[selectedStatus]?.static ?? 0}`,
                                tooltipPlacement: 'top-start'
                            },
                            {
                                name: 'Risk-based',
                                value: policyType?.[selectedStatus]?.riskBased ?? 0,
                                fill: ChartColors['data-bg-main-3'],
                                tooltipContent: `Risk-based polices: ${policyType?.[selectedStatus]?.riskBased ?? 0}`,
                                tooltipPlacement: 'top-start'
                            }
                        ]}
                        isLoading={policyTypeIsLoading}
                    />
                </div>
            }
        />
    );
};

export default PolicyTypeChart;
